export { default as VerificationDetails } from './VerificationDetails';
export { default as IndividualDetailsForm } from './IndividualDetailsForm';
export { default as IndividualVerificationForm } from './IndividualVerificationForm';
export { default as CompanyDetailsForm } from './CompanyDetailsForm';
export { default as CompanyVerificationForm } from './CompanyVerificationForm';
export { default as ExtendedVerificationForm } from './ExtendedVerificationForm';
export { default as Heading } from './Heading';
export { default as Alert } from './Alert';
export { default as UploadBox } from './UploadBox';
